import {Locale} from '../../../../../../../../../provider/locale/localization';
import {LangKeyType} from '../../../../../../../../../provider/locale/translation/type';
import {ExtraItemContentValidationSettingsType} from '../../../content-step-type';

type PropsType = {
    requirements?: ExtraItemContentValidationSettingsType;
};

export function VideoRequirements(props: PropsType): JSX.Element | null {
    const {requirements} = props;

    if (Object.values(requirements || {}).length === 0) {
        return null;
    }

    return (
        <>
            <Locale stringKey="POSTS_REQUIREMENTS__VIDEO" />
            <ul>
                {Object.values(requirements || {}).map((extra: LangKeyType) => {
                    return (
                        <li key={extra}>
                            <Locale stringKey={extra} />
                        </li>
                    );
                })}
            </ul>
        </>
    );
}
